<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" ref="searchform">
						<el-form-item label="设备IMEI" prop="imei">
							<el-input placeholder="设备IMEI" v-model="formInline.imei"></el-input>
						</el-form-item>
						<!-- <el-form-item :label="$t('device.vesting')" prop="client_id">
              <el-cascader
                  :options="options"
                  :placeholder="$t('device.vesting')"
                  v-model="formInline.client_id"
              ></el-cascader>
            </el-form-item> -->
						<el-form-item>
							<el-button @click="searchCont" type="primary">{{ $t('device.inquire') }}</el-button>
							<el-button @click="resetBtn" type="primary">{{ $t('device.reset') }}</el-button>
						</el-form-item>
					</el-form>

					<div>
						<el-button type="primary" @click="toClockSend()">
							{{ $t('index.clock_send') }}
						</el-button>
					</div>
				</div>
			</template>
			<el-table :data="listData" :default-sort="{prop: 'date', order: 'descending'}"
				@selection-change="tableSelected" @sort-change="sortChange" border ref="userlistTable" stripe
				style="width: 100%">

				<el-table-column :label="$t('index.device')" prop="imei" width="180"></el-table-column>
				<el-table-column :label="$t('menu.clock')" prop="content" width="600">
          <template #default="{ row }">
            <div v-if="isValidClockJson(row.content)">
              <div><strong>{{ $t('index.clock_content') }}：</strong>{{ getClockContent(row.content) }}</div>
              <div><strong>{{ $t('index.clock_time') }}：</strong>{{ getClockTime(row.content) }}</div>
              <div><strong>{{ $t('index.clock_cycle') }}：</strong>{{ getClockCycle(row.content) }}</div>
            </div>
            <div v-else>
              {{ row.content }}
            </div>
          </template>
        </el-table-column>
				<el-table-column :label="$t('device.creation_time')" prop="create_at" width="200"></el-table-column>
				<el-table-column :label="$t('index.notice_is_send')" prop="is_send_text" width="200"></el-table-column>
				<el-table-column :label="$t('index.notice_send_time')" prop="update_at" width="200"></el-table-column>
			</el-table>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20,50]" :total="pageTotal"
				@current-change="handleCurrentChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>
	</div>
</template>
<script>
	import device from "@/model/device";
	import client from "../../model/client";

	export default {
		name: "userApp",
		data() {
			return {
				pageTotal: 0,
				formInline: {
					imei: "",
					client_id: "",
					type: 2,
					page: 1,
					size: 10
				},
				listData: [],
				typeData: [],
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
				orderParam: {
					prop: "",
					order: ""
				},
				weekDays: [
					{ label: this.$t('device.monday'), value: 1 },
					{ label: this.$t('device.tuesday'), value: 2 },
					{ label: this.$t('device.wednesday'), value: 3 },
					{ label: this.$t('device.thursday'), value: 4 },
					{ label: this.$t('device.friday'), value: 5 },
					{ label: this.$t('device.saturday'), value: 6 },
					{ label: this.$t('device.sunday'), value: 7 }
				]
			};
		},
		async mounted() {
			await this.noticeList();
		},

		methods: {
			// 检查是否是有效的闹钟JSON
			isValidClockJson(content) {
				try {
					const data = JSON.parse(content);
					return data.clock_content !== undefined && 
             data.clock_time !== undefined && 
             data.clock_cycle !== undefined;
				} catch (e) {
					return false;
				}
			},
			
			// 获取闹钟内容
			getClockContent(content) {
				try {
					const data = JSON.parse(content);
					return data.clock_content || '-';
				} catch (e) {
					return content;
				}
			},
			
			// 获取闹钟时间
			getClockTime(content) {
				try {
					const data = JSON.parse(content);
					return data.clock_time || '-';
				} catch (e) {
					return '-';
				}
			},
			
			// 获取闹钟周期（转换为星期几）
			getClockCycle(content) {
				try {
					const data = JSON.parse(content);
					if (!data.clock_cycle || !Array.isArray(data.clock_cycle)) return '-';
					
					// 将数字转换为星期几
					return data.clock_cycle.map(day => {
						const dayObj = this.weekDays.find(d => d.value === day);
						return dayObj ? dayObj.label : day;
					}).join('、');
				} catch (e) {
					return '-';
				}
			},
			
			async noticeList() {
				const ret = await device.noticeList(this.formInline);
				if (ret.code === 200) {
					this.listData = ret.data.list;
					this.pageTotal = ret.data.count;
				}
			},
			async clientList() {
				const ret = await client.list();
				if (ret.code === 200) {
					this.options = this.handleClientTree(ret.data)
				}
			},
			handleClientTree(data) {
				if (data.length === 0) {
					return []
				}
				let options = []
				data.forEach(item => {
					options.push({
						value: item.id,
						label: item.name
					})
					if (item.children.length > 0) {
						options.push({
							value: item.id,
							label: item.name,
							children: this.handleClientTree(item.children)
						})
					}
				})
				return options
			},
			searchCont() {
				this.noticeList();
			},
			resetBtn() {
				this.$refs.searchform.resetFields();
				this.noticeList();
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.noticeList();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.noticeList();
			},
			toClockSend() {
				this.$router.push({
					path: "/device/clock"
				});
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.demo-form-inline .el-input {
		--el-input-width: 220px;
	}

	.demo-form-inline .el-select {
		--el-select-width: 220px;
	}
</style>